import { unsafeCSS } from 'lit-element';
import { tablet } from './breakpoints';

export const layoutMinWidth = 320;
export const layoutMaxWidth = 1180;

export const layoutWidthByBreakpoint = {
  // на мобиле резина
  tablet: 660,
  desktop: 940,
  largeDesktop: layoutMaxWidth,
};

export const padding = {
  mobile: 16,
  tablet: 54,
  desktop: 42,
  largeDesktop: 10,
};

export const createLayout = (selector = ':host', includeGaps = true) => {
  const maxWidth = layoutMaxWidth + includeGaps * (padding.largeDesktop * 2);

  return unsafeCSS(`
    ${selector} {
        box-sizing: border-box;
        min-width: var(--layout-min-width);
        width: 100%;
        max-width: ${maxWidth}px;
        ${includeGaps ? unsafeCSS(`padding-left: var(--layout-gap); padding-right: var(--layout-gap);`) : ''}
      }
      
      

      ${tablet(
        unsafeCSS(`
        ${selector} {
          width: calc(var(--layout-width) + 2 * var(--layout-gap));
          margin-left: auto;
          margin-right: auto;
        }
      `)
      )}`);
};
